module.exports = __webpack_public_path__ + "static/media/play_button_mobile.cae6174f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play_button_mobile.svg
// module id = 540
// module chunks = 0